<template>
  <div>
    <form>
      <div class="p-fluid p-formgrid p-grid p-mt-5 p-mb-5">
        <div class="p-field p-col-12 p-md-4">
          <label>Document</label>
          <div class="p-field p-col-12 p-md-8">
            <Radiobutton id="passport" value="Passport" v-model="document"/>
            <label for="passport">Passport</label>
            <Radiobutton id="citizenship" value="Citizenship" v-model="document"/>
            <label for="citizenship">Citizenship</label>
          </div>
        </div>
        <div class="p-field p-col-12 p-md-4">
          <label for="number">Number</label>
          <InputText id="number" v-model="number"/>
        </div>
        <div class="p-field p-col-12 p-md-4">
          <label for="issuedDate">Issued Date</label>
          <date-picker v-model="issuedDate" valueType="format" v-if="!englishDateEnabled"/>
          <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="issuedDate"
                     v-model="issuedDate"/>
        </div>
        <div class="p-field p-col-12 p-md-4">
          <label for="expiredDate">Expiry Date</label>
          <date-picker v-model="expiryDate" valueType="format" v-if="!englishDateEnabled"/>
          <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="expiredDate"
                     v-model="expiryDate"/>
        </div>
        <div class="p-field p-col-12 p-md-4">
          <label for="eligible">Eligible Status</label>
          <input-text id="eligible" v-model="eligibleStatus"/>
        </div>
        <div class="p-field p-col-12 p-md-4">
          <label for="issuedBy">Issued By</label>
          <Dropdown v-model="issuedBy" optionLabel="name" placeholder="--Select--"
                    id="issuedBy"/>
        </div>
        <div class="p-field p-col-12 p-md-4">
          <label for="eligibleReviewDate">Eligible Review Date</label>
          <date-picker v-model="eligibleReviewDate" valueType="format" v-if="!englishDateEnabled"/>
          <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="eligibleReviewDate"
                     v-model="eligibleReviewDate"/>
        </div>
        <div class="p-field p-col-12 p-md-4">
          <label for="comment">Comment</label>
          <Textarea id="comment" v-model="reason" rows="5" cols="30"/>
        </div>
      </div>
      <hr/>
      <div class="p-fluid p-formgrid p-grid p-mt-5 p-mb-5">
        <div class="p-field p-col-12 p-md-1">
          <Button class="p-button-raised" label="Save" icon="pi pi-save"/>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Dropdown from 'primevue/dropdown'
import DatePicker from 'vue2-datepicker'
import $ from 'jquery'
import InputMask from 'primevue/inputmask'
import Radiobutton from 'primevue/radiobutton'
import Textarea from 'primevue/textarea'

export default {
  name: 'immigration',
  data() {
    return {
      name: '',
      document: '',
      number: '',
      stateNumber: '',
      filters: {},
      issuedDate: null,
      expiryDate: null,
      eligibleReviewDate: null,
      eligibleStatus: '',
      issuedBy: {},
      reason: '',
      englishDateEnabled: true,
      loading: false,
      editing: false,
      holidayId: null
    }
  },
  mounted() {
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
  },
  methods: {
    async addHoliday() {
      if (this.name === '') {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Name cannot be empty!', life: 3000})
        return
      }
      let holiday = {
        id: this.holidayId,
        value: this.name
      }
      let response = ''
      try {
        if (!this.editing) {
          this.loading = true
          response = await this.$store.dispatch('createHrMasterSetup', holiday)
          this.loading = false
        } else {
          this.loading = true
          response = await this.$store.dispatch('updateHrMasterSetup', holiday)
          this.loading = false
        }
        if (response.data.status === 'SUCCESS') {
          this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 3000})
        }
      } catch (e) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Something went wrong!!', life: 3000})
        this.loading = false
        return
      }
      this.reset()
    },
    reset() {
      this.name = ''
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.issuedDate = this.$store.getters.nepaliNewDate
        this.expiryDate = this.$store.getters.nepaliNewDate
        this.eligibleReviewDate = this.$store.getters.nepaliNewDate
      }
    },
    setEnglishDate() {
      this.issuedDate = new Date().toISOString().slice(0, 10)
      this.expiryDate = new Date().toISOString().slice(0, 10)
      this.eligibleReviewDate = new Date().toISOString().slice(0, 10)
    },
    nepaliDate() {
      $('#issuedDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        onChange: () => {
          this.issuedDate = $('#issuedDate').val()
        }
      })
      $('#expiredDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        onChange: () => {
          this.expiryDate = $('#expiredDate').val()
        }
      })
      $('#eligibleReviewDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        onChange: () => {
          this.eligibleReviewDate = $('#eligibleReviewDate').val()
        }
      })
    }
  },
  components: {
    Button,
    InputText,
    Dropdown,
    DatePicker,
    InputMask,
    Radiobutton,
    Textarea
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// immigration.vue?907ad3de